function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-onboarding-mode" },
    [
      _vm._l(_vm.cards, function(ref) {
        var id = ref.id
        var title = ref.title
        var rest = objectWithoutProperties(ref, ["id", "title"])
        var card = rest
        return [
          card.active
            ? _c("div", { key: card.id, staticClass: "mode-card" }, [
                _vm.isRecommandedMode(id)
                  ? _c("div", { staticClass: "mode-card__tag" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "mode-card__tag-label typographies-paragraph-small-semibold"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$l10n.__("Recommandé")) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mode-card__container" }, [
                  _c("div", { staticClass: "mode-card__header" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "mode-card__header-title typographies-heading-h3"
                      },
                      [_vm._v(_vm._s(title))]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "mode-card__header-subtitle typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(card.subtitle) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mode-card__content" },
                    _vm._l(card.features, function(ref, index) {
                      var icon = ref.icon
                      var title = ref.title
                      var description = ref.description
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "mode-card__content-feature"
                        },
                        [
                          _c("i", { class: icon }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mode-card__content-feature-informations"
                            },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "mode-card__content-feature-informations-title typographies-paragraph-medium-bold"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(title) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "mode-card__content-feature-informations-description"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(description) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mode-card__actions" },
                    [
                      _c("CompassLink", {
                        attrs: {
                          label: card.action.moreDetails.label,
                          link: card.action.moreDetails.href,
                          target: "_blank"
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          disabled: _vm.isDisabledMode(id),
                          label: card.action.select.label
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("validMode", {
                              id: id,
                              title: title
                            })
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }